module.exports = __webpack_public_path__ + "files/1fa096e46a970cc73b18a91d7f071b11.png";